import { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { IconBack } from "../../../component/IconSvg";
import { asyncWrapper } from "../../../utils/AppFunction";
import { ModalBaseProps } from "../../../utils/models";
import { getPatientDetail } from "../../services/PatientServices";
import MedicalRecordList from "./MedicalRecordList";
import PatientInfo from "./PatientInfo";

type Props = ModalBaseProps & {
	patientInfo?: any;
};

const PatientInfoModal = ({ open, onClose, patientInfo }: Props) => {
	const [patientData, setPatientData] = useState<any>();

	useEffect(() => {
		if (patientInfo?.id) {
			getPatientData(patientInfo.id);
		}
	}, [patientInfo?.id]);

	const getPatientData = async (patientId: string) => {
		const [data] = await asyncWrapper<any>(getPatientDetail(patientId));
		setPatientData(data);
	};

	return (
		<Modal show={open} size="xl" centered scrollable onHide={onClose}>
			<Modal.Header className="py-3" closeButton>
				<Modal.Title>Thông tin bệnh nhân</Modal.Title>
			</Modal.Header>

			<Modal.Body className="bg-white">
				<PatientInfo patientInfo={patientData} />
				<div className="separator spaces my-16"></div>
				<MedicalRecordList data={patientData?.medicalRecords ?? []} />
			</Modal.Body>

			<Modal.Footer>
				<Button className="btn-danger" onClick={onClose}>
					Đóng
				</Button>
			</Modal.Footer>
		</Modal>
	);
};

export default PatientInfoModal;
